import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function DailySalesHeader() { return ( <ContentHeader title='Daily Sales Report' /> ) }

export default React.memo(DailySalesHeader)
